export default __webpack_public_path__ + "b3672b28111d938781a61ae399b7c679.png";